export default __webpack_public_path__ + "static/media/A20.01504c7b.webp";